// Demo data for offline/demo mode when server is unavailable
// This allows Apple reviewers to test the app without access to local network

export const DEMO_MODE = {
  enabled: false, // Auto-detected based on server availability
  timestamp: null,
};

export const demoUser = {
  id: 1,
  email: 'demo@produksjonsstyring.no',
  name: 'Demo Bruker',
  isAdmin: true,
  roleName: 'Verkstedsforman',
  can_create_work_order: true,
};

export const demoTeams = [
  { id: 1, team_name: 'VANNSKJÆRING', description: 'Vannskjæring', team_leader_id: 2 },
  { id: 2, team_name: 'PLASMA', description: 'Plasma skjæring', team_leader_id: 2 },
  { id: 3, team_name: 'AUTOGEN', description: 'Autogen skjæring', team_leader_id: 2 },
  { id: 4, team_name: 'SVEIS', description: 'Sveising', team_leader_id: 3 },
  { id: 5, team_name: 'BUKSERING', description: 'Buksering', team_leader_id: null },
  { id: 6, team_name: 'KANTPRESS', description: 'Kantpress', team_leader_id: null },
];

export const demoEmployees = [
  { 
    id: 1, 
    user_id: 1, 
    firstName: 'Demo', 
    lastName: 'Bruker', 
    email: 'demo@produksjonsstyring.no',
    phone: '+47 123 45 678',
    role_id: 6, 
    roleName: 'Verkstedsforman' 
  },
  { 
    id: 2, 
    user_id: 2, 
    firstName: 'Emir', 
    lastName: 'Muric', 
    email: 'emir.muric@produksjonsstyring.no',
    phone: '+47 234 56 789',
    role_id: 5, 
    roleName: 'Forman' 
  },
  { 
    id: 3, 
    user_id: 3, 
    firstName: 'Georg', 
    lastName: 'Haslie', 
    email: 'georg.haslie@produksjonsstyring.no',
    phone: '+47 345 67 890',
    role_id: 6, 
    roleName: 'Verkstedsforman' 
  },
  { 
    id: 4, 
    user_id: 4, 
    firstName: 'Robin', 
    lastName: 'Olsen', 
    email: 'robin.olsen@produksjonsstyring.no',
    phone: '+47 456 78 901',
    role_id: 4, 
    roleName: 'Operatør' 
  },
  { 
    id: 5, 
    user_id: 5, 
    firstName: 'Stian', 
    lastName: 'Hagen', 
    email: 'stian.hagen@produksjonsstyring.no',
    phone: '+47 567 89 012',
    role_id: 4, 
    roleName: 'Operatør' 
  },
  { 
    id: 6, 
    user_id: null, 
    firstName: 'Ola', 
    lastName: 'Nordmann', 
    email: 'ola.nordmann@produksjonsstyring.no',
    phone: null,
    role_id: 4, 
    roleName: 'Operatør' 
  },
];

export const demoWorkOrders = [
  {
    id: 1,
    order_number: 'AO-2024-001',
    customer_name: 'DEMO Kunde AS',
    project_name: 'Demo Prosjekt 1',
    status: 'I gang',
    priority: 'Høy',
    deadline: '2025-01-15',
    created_at: '2024-12-01T10:00:00Z',
    created_by: 1,
    is_stopped: false,
    file_location: '//server/demo/AO-2024-001',
    description: 'Demo arbeidsordre for testing',
    team_sequence: [
      { team_id: 1, sequence: 1, status: 'Ferdig', team_name: 'VANNSKJÆRING' },
      { team_id: 4, sequence: 2, status: 'I gang', team_name: 'SVEIS' },
      { team_id: 6, sequence: 3, status: 'Ikke startet', team_name: 'KANTPRESS' },
    ],
  },
  {
    id: 2,
    order_number: 'AO-2024-002',
    customer_name: 'Test Bedrift AS',
    project_name: 'Test Prosjekt',
    status: 'Ikke startet',
    priority: 'Normal',
    deadline: '2025-01-20',
    created_at: '2024-12-05T14:30:00Z',
    created_by: 1,
    is_stopped: false,
    file_location: '//server/demo/AO-2024-002',
    description: 'Test arbeidsordre',
    team_sequence: [
      { team_id: 2, sequence: 1, status: 'Ikke startet', team_name: 'PLASMA' },
      { team_id: 4, sequence: 2, status: 'Ikke startet', team_name: 'SVEIS' },
    ],
  },
  {
    id: 3,
    order_number: 'AO-2024-003',
    customer_name: 'Eksempel Industri',
    project_name: 'Produksjonstest',
    status: 'Ferdig',
    priority: 'Lav',
    deadline: '2024-12-10',
    created_at: '2024-11-20T09:00:00Z',
    created_by: 2,
    is_stopped: false,
    file_location: '//server/demo/AO-2024-003',
    description: 'Ferdig arbeidsordre',
    team_sequence: [
      { team_id: 1, sequence: 1, status: 'Ferdig', team_name: 'VANNSKJÆRING' },
      { team_id: 4, sequence: 2, status: 'Ferdig', team_name: 'SVEIS' },
      { team_id: 5, sequence: 3, status: 'Ferdig', team_name: 'BUKSERING' },
    ],
  },
];

export const demoMachines = [
  { id: 1, machine_name: 'Vannskjærer 1', team_id: 1, status: 'Aktiv' },
  { id: 2, machine_name: 'Plasma 1', team_id: 2, status: 'Aktiv' },
  { id: 3, machine_name: 'Kantpress 1', team_id: 6, status: 'Aktiv' },
];

export const demoComments = [
  {
    id: 1,
    work_order_id: 1,
    user_id: 2,
    user_name: 'Emir Muric',
    comment_text: 'Vannskjæring ferdig. Klar for sveis.',
    created_at: '2024-12-10T11:30:00Z',
  },
  {
    id: 2,
    work_order_id: 1,
    user_id: 3,
    user_name: 'Georg Haslie',
    comment_text: 'Materialkvalitet ser bra ut.',
    created_at: '2024-12-11T09:15:00Z',
  },
];

export const demoStatistics = {
  totalOrders: 45,
  completedOrders: 32,
  inProgressOrders: 8,
  stoppedOrders: 2,
  notStartedOrders: 3,
  averageCompletionTime: 5.2,
  teamEfficiency: [
    { team_name: 'VANNSKJÆRING', efficiency: 92, completed: 28 },
    { team_name: 'PLASMA', efficiency: 88, completed: 25 },
    { team_name: 'SVEIS', efficiency: 85, completed: 30 },
    { team_name: 'KANTPRESS', efficiency: 90, completed: 22 },
  ],
};

// Helper to generate realistic demo data
export const generateDemoTeamStatus = (workOrderId, teamId) => {
  return {
    id: Math.random(),
    work_order_id: workOrderId,
    team_id: teamId,
    status: 'I gang',
    updated_at: new Date().toISOString(),
    updated_by: 2,
    updated_by_name: 'Demo Bruker',
  };
};

export const generateDemoNotification = (message) => {
  return {
    id: Math.random(),
    user_id: 1,
    message: message,
    is_read: false,
    created_at: new Date().toISOString(),
    type: 'info',
  };
};
